/* eslint-disable no-useless-catch */

/**
 * Auth service
 */

// Models
import { IDetailUserService, IParamGetList, IUserServiceUpdateRequest } from 'models/UserRequest';

// Constants
import { HTTP_METHOD } from 'utils/constants';

// Models
import { DeleteRequest } from 'models/DeleteRequest';

// Configs
import AdminService from 'configs/api/adminService';
import { constructEndpoint } from 'utils/helper/common';

const ENDPOINTS = {
  API_GET_USERS: ['/users', HTTP_METHOD.GET],
  API_DELETE_USER: ['/users/$0', HTTP_METHOD.DELETE],
  API_USERS_EXPORT: ['/users/export', HTTP_METHOD.GET],
  API_GET_USER_SERVICE: ['/users/{0}/services', HTTP_METHOD.GET],
  API_UPDATE_USER_SERVICE: ['/users/{0}/services', HTTP_METHOD.PUT],
};

class UserService extends AdminService {
  constructor() {
    super();
  }

  async getUsers(params?: IParamGetList) {
    try {
      const results = await this.request(ENDPOINTS.API_GET_USERS, [], null, params);
      return results?.data?.results;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }

  async deleteUser(data: DeleteRequest) {
    try {
      const results = await this.request(ENDPOINTS.API_DELETE_USER, [data?.id]);
      return results?.data?.results;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }

  async exportUsers(data?: IParamGetList): Promise<any> {
    try {
      const results = await this.request(
        ENDPOINTS.API_USERS_EXPORT,
        [],
        { responseType: 'blob' },
        data
      );
      return results;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }

  async getListUserService(idUser: string | number): Promise<IDetailUserService[]> {
    try {
      const results = await this.request(
        constructEndpoint(ENDPOINTS.API_GET_USER_SERVICE, [idUser])
      );
      return results.data.results;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }

  async updateUserService(idUser: string | number, data: IUserServiceUpdateRequest[]) {
    try {
      const results = await this.request(
        constructEndpoint(ENDPOINTS.API_UPDATE_USER_SERVICE, [idUser]),
        [],
        data
      );
      return results.data;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }
}

export default new UserService();
